module.exports = "/images/vendor/flag-icon-css/flags/1x1/az.svg?0b4258df02490e0504d93c20984c467d";